// extracted by mini-css-extract-plugin
export var content = "MultiVideoDisplay-module--content--2427b";
export var innerWrapper = "MultiVideoDisplay-module--innerWrapper--c44d0";
export var videoCard = "MultiVideoDisplay-module--videoCard--353ee";
export var wrapper = "MultiVideoDisplay-module--wrapper--f5573";